// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ShoppingBag24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ShoppingBag24: FC<ShoppingBag24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V8c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 6h2c0-1.383.487-2.563 1.463-3.538C9.438 1.487 10.617 1 12 1s2.563.488 3.537 1.462C16.512 3.438 17 4.617 17 6h2c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22H5Zm0-2h14V8H5v12Zm7-6c1.383 0 2.563-.488 3.537-1.463C16.512 11.563 17 10.383 17 9h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0 1 12 12a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 9H7c0 1.383.487 2.563 1.463 3.537C9.438 13.512 10.617 14 12 14ZM9 6h6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 6Z" />
        </svg>
    );
};

export default ShoppingBag24;
